export default {
  saveItem(id, data) {
    window.localStorage.setItem(id, JSON.stringify(data));
  },

  getItem(id) {
    let item = JSON.parse(window.localStorage.getItem(id));
    return item || null;
  },

  removeItem(id) {
    window.localStorage.removeItem(id);
  },
};
